import { calculateTableDimensions } from "./drawingObjects/drawTable";
import { rotateCoordsSection, rotateCoordsTable } from "./rotateCoordinates";

export const handleSelection = (
  objects,
  event,
  mouseX,
  mouseY,
  selectedCircles,
  selectedTableCircles,
  setSelectedCircles,
  setSelectedTableCircles,
  circleRadius,
  circlePadding,
  edgePadding,
  selectedArea,
  setSelectedArea,
  HoldTypes,
  setOpenAccessCode,
  setCurrentHold,
  successAccess,
  setSuccessAccess,
  setAccessCode,
  currentHolds,
  setTierError,
  setSoldError,
  seatingTickets
) => {
  const filterUniqueSelectedCircles = (newFiltered) => {
    const uniqueSeats = newFiltered.reduce((acc, circle) => {
      acc[circle.seatId] = circle;
      return acc; // Return the accumulator
    }, {});

    return Object.values(uniqueSeats);
  };
  const filterUniqueSelectedAreas = (newFiltered) => {
    const uniqueSeats = newFiltered.reduce((acc, circle) => {
      acc[circle.id] = circle;
      return acc; // Return the accumulator
    }, {});

    return Object.values(uniqueSeats);
  };

  const filterUniqueSelectedTableCircles = (newFiltered) => {
    // Use reduce to create an object where the keys are unique seatIds
    const uniqueSeats = newFiltered.reduce((acc, circle) => {
      acc[circle.itemID] = circle;
      return acc;
    }, {});
    return Object.values(uniqueSeats);
  };
  function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }
  function filterByTierID(lastUpdatedArray) {
    if (
      (selectedCircles.length === 0 &&
        selectedTableCircles.length === 0 &&
        selectedArea.length === 0) ||
      lastUpdatedArray.length === 0
    )
      return;
    const lastUpdatedTierIDs = lastUpdatedArray.map(
      (item) => item.TierID || item.tierID
    );

    /*
    array of table circles
    array of circles
    array of areas

    1. extract the tierID from the last updated array 
    2. filter the areas, circles and table circles based on the last updated tierID
    
    */

    const lastUpdatedTierID = lastUpdatedTierIDs[lastUpdatedTierIDs.length - 1];
    console.log(lastUpdatedTierID);
    const filterArrayByTierID = (array) => {
      console.log(
        array.filter(
          (item) => (item.TierID || item.tierID) === lastUpdatedTierID
          // lastUpdatedTierID.includes(item.TierID || item.tierID)
        )
      );
      return array.filter(
        (item) => (item.TierID || item.tierID) === lastUpdatedTierID
        // lastUpdatedTierID.includes(item.TierID || item.tierID)
      );
    };

    const filteredCircles = filterArrayByTierID(selectedCircles);
    const filteredTableCircles = filterArrayByTierID(selectedTableCircles);
    const filteredArea = filterArrayByTierID(selectedArea);
    const isCirclesUpdated = !arraysEqual(filteredCircles, selectedCircles);
    const isTableCirclesUpdated = !arraysEqual(
      filteredTableCircles,
      selectedTableCircles
    );
    const isAreaUpdated = !arraysEqual(filteredArea, selectedArea);

    if (isCirclesUpdated || isTableCirclesUpdated || isAreaUpdated) {
      setSelectedCircles(filteredCircles);
      setSelectedTableCircles(filteredTableCircles);
      setSelectedArea(filteredArea);
      setTierError(true);
    }
    // select the last updated
  }
  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };
  let foundObject;
  foundObject = objects.forEach((obj) => {
    if (obj.type === "matrix") {
      if (!obj.matrix) return;

      // if(obj.id)
      const spacing = obj.itemRadius * 2.2; // Assuming the same spacing as used in drawObjects
      const totalWidth =
        spacing * (obj.matrix[0].length - 1) + obj.itemRadius * 2; // Total width of the matrix
      const totalHeight =
        spacing * (obj.matrix.length - 1) + obj.itemRadius * 2; // Total height of the matrix

      const centerX = obj.x + totalWidth / 2;
      const centerY = obj.y + totalHeight / 2;
      const translatedMouseX = mouseX - centerX;
      const translatedMouseY = mouseY - centerY;

      // Reverse the rotation
      const angle = (-obj.rotation * Math.PI) / 180; // Convert degrees to radians and reverse
      const rotatedMouseX =
        translatedMouseX * Math.cos(angle) - translatedMouseY * Math.sin(angle);
      const rotatedMouseY =
        translatedMouseX * Math.sin(angle) + translatedMouseY * Math.cos(angle);

      for (let rowIndex = 0; rowIndex < obj.matrix.length; rowIndex++) {
        const rowLength = obj.matrix[0].length;
        const middleIndex = (rowLength - 1) / 2; // Middle index of the row
        for (
          let columnIndex = 0;
          columnIndex < obj.matrix[rowIndex].length;
          columnIndex++
        ) {
          // const deleted = obj.matrix[rowIndex][columnIndex].deleted;
          // console.log(deleted);
          const distanceFromMiddle = Math.abs(columnIndex - middleIndex);
          let curveOffset = 0;
          // Apply a curve formula: The farther from the middle, the lower the y-value
          if (obj.useCurveRows && obj.curveFactor)
            curveOffset =
              obj.curveFactor * (1 - (distanceFromMiddle / middleIndex) ** 2);

          // -----------
          const spacing = obj.itemRadius * 2.2; // Adjust spacing based on your needs
          const totalWidth =
            spacing * (obj.matrix[0].length - 1) + obj.itemRadius * 2;
          const totalHeight =
            spacing * (obj.matrix.length - 1) + obj.itemRadius * 2;
          const centerX = obj.x + totalWidth / 2;
          const centerY = obj.y + totalHeight / 2;
          // -----------
          const circleX = obj.x + columnIndex * spacing + obj.itemRadius;
          const circleY =
            obj.y + rowIndex * spacing + obj.itemRadius + curveOffset;
          const newCoord = rotateCoordsSection(
            circleX,
            circleY,
            centerX,
            centerY,
            -obj.rotation
          );
          const distance = Math.sqrt(
            (mouseX - newCoord.x) ** 2 + (mouseY - newCoord.y) ** 2
          );
          const assigned = findTicket(obj.matrix[rowIndex][columnIndex].tierID);
          if (
            obj.matrix[rowIndex][columnIndex].id ===
            "ffbb3868-61d5-40a4-93c4-bb94c524a093-1-1"
          ) {
            console.log(distance, obj.itemRadius);
            console.log(
              obj.matrix[rowIndex][columnIndex],
              distance <= obj.itemRadius
            );
          }

          if (distance <= obj.itemRadius && assigned) {
            const seatId = obj.matrix[rowIndex][columnIndex].id;
            const deleted = obj.matrix[rowIndex][columnIndex].deleted;
            const HoldID = obj.matrix[rowIndex][columnIndex].holdID;
            const accessCode = obj.matrix[rowIndex][columnIndex];
            const TierID = obj.matrix[rowIndex][columnIndex].tierID;
            const isTaken = obj.matrix[rowIndex][columnIndex].isTaken;
            const seatName = obj.matrix[rowIndex][columnIndex].name;
            const HoldAccess = HoldTypes.filter(
              (hold) => hold.HoldID === HoldID
            );
            setCurrentHold(HoldAccess);

            const selected = selectedCircles.find(
              (selection) =>
                selection.objectId === obj.id &&
                selection.rowIndex === rowIndex &&
                selection.columnIndex === columnIndex &&
                selection.seatId === seatId
            );
            if (selected !== undefined) {
              // Circle already selected, remove it from selection
              setSelectedCircles((current) =>
                current.filter(
                  (circle) =>
                    !(
                      circle.objectId === obj.id &&
                      circle.rowIndex === rowIndex &&
                      circle.columnIndex === columnIndex &&
                      circle.seatId === seatId
                    )
                )
              );
            } else {
              // New selection, add circle to selectedCircles
              console.log(obj.matrix[rowIndex][columnIndex]);

              const isOpened =
                currentHolds.find((hold) => {
                  return hold.HoldID === HoldID;
                }) != undefined;
              if (
                HoldID &&
                HoldAccess.length > 0 &&
                HoldAccess[0].accessCode &&
                HoldAccess[0].accessCode.length > 0 &&
                !isTaken &&
                !isOpened &&
                !deleted
              ) {
                setOpenAccessCode(true);
              } else {
                if (isOpened && !isTaken && !deleted) {
                  setSelectedCircles((current) => {
                    let newFiltered = [
                      ...current,
                      {
                        objectId: obj.id,
                        rowIndex,
                        columnIndex,
                        seatId,
                        deleted,
                        HoldID,
                        TierID,
                        sectionName: obj.name,
                        seatName,
                        startFrom: obj.startFrom,
                      },
                    ];
                    const filtered = filterUniqueSelectedCircles(newFiltered);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
                if (!HoldID && !isTaken && !deleted) {
                  setSelectedCircles((current) => {
                    let newFiltered = [
                      ...current,
                      {
                        objectId: obj.id,
                        rowIndex,
                        columnIndex,
                        seatId,
                        deleted,
                        HoldID,
                        TierID,
                        sectionName: obj.name,
                        seatName,
                        startFrom: obj.startFrom,
                      },
                    ];
                    const filtered = filterUniqueSelectedCircles(newFiltered);
                    filterByTierID(filtered);
                    return filtered;
                  });
                } else {
                  console.log("here locked seat");
                  setSoldError(true);
                }
              }
            }
            // Prevent further actions if a circle is selected/deselected
            event.stopPropagation();
            event.preventDefault();
          }
        }
      }

      return (
        rotatedMouseX >= -totalWidth / 2 &&
        rotatedMouseX <= totalWidth / 2 &&
        rotatedMouseY >= -totalHeight / 2 &&
        rotatedMouseY <= totalHeight / 2
      );
    }  else if (obj.type === "table") {
  // 1) Compute dimensions & center (same as drawTable)
  const { adjustedWidth, adjustedHeight, leftCount, topCount } =
    calculateTableDimensions(obj, circleRadius, edgePadding);

  // center relative to obj.x/obj.y
  const centerXRel = circleRadius + edgePadding + adjustedWidth / 2;
  const centerYRel = circleRadius + edgePadding + adjustedHeight / 2;
  // center in world coords
  const centerXWorld = obj.x + centerXRel;
  const centerYWorld = obj.y + centerYRel;

  // Helper: layout logic is identical to drawTable, gives raw (unrotated) positions
  const getCircleCoordinates = (side, index) => {
    const baseOffset =
      (index + 1) * (2 * circleRadius + circlePadding) -
      circleRadius +
      edgePadding;
    const offsetY = baseOffset + (topCount > 0 ? circleRadius : 0);
    const offsetX = baseOffset + (leftCount > 0 ? circleRadius : 0);

    let localX = 0, localY = 0;
    switch (side) {
      case "left":
        localX = 0;
        localY = offsetY;
        break;
      case "right":
        localX = adjustedWidth + circleRadius * 2 + edgePadding * 2;
        localY = offsetY;
        break;
      case "top":
        localX = offsetX;
        localY = 0;
        break;
      case "bottom":
        localX = offsetX;
        localY = adjustedHeight + circleRadius * 2 + edgePadding * 2;
        break;
      default:
        localX = 0;
        localY = 0;
    }
    return { x: obj.x + localX, y: obj.y + localY };
  };

  // 2) For each item, rotate its raw coords into world space & hit-test
  let counters = { left: 0, right: 0, top: 0, bottom: 0 };
  for (let i = 0; i < obj.items.length; i++) {
    const item = obj.items[i];
    const count = counters[item.side]++;
    // raw (unrotated) position
    const rawPos = getCircleCoordinates(item.side, count);
    // rotate it around the table’s center by +rotation
    const worldPos = rotateCoordsTable(
      rawPos.x,
      rawPos.y,
      centerXWorld,
      centerYWorld,
      obj.rotation
    );

    // now simple distance test in world coords
    const dx = mouseX - worldPos.x;
    const dy = mouseY - worldPos.y;
    if (dx * dx + dy * dy > circleRadius * circleRadius) {
      continue;
    }

    // === at this point we've clicked *inside* this circle ===
    const assigned = findTicket(item.tierID);
    if (!assigned) continue;

    const HoldID = item.holdID;
    const HoldAccess = HoldTypes.filter((h) => h.HoldID === HoldID);
    const isOpened = currentHolds.some((h) => h.HoldID === HoldID);
    setCurrentHold(HoldAccess);

    const selIndex = selectedTableCircles.findIndex(
      (sel) => sel.objectId === obj.id && sel.itemID === item.id
    );

    if (selIndex >= 0) {
      setSelectedTableCircles((curr) => curr.filter((_, j) => j !== selIndex));
    } else {
      const shouldOpen =
        HoldID &&
        HoldAccess.length > 0 &&
        HoldAccess[0].accessCode?.length > 0 &&
        !item.isTaken &&
        !isOpened;
      if (shouldOpen) {
        setOpenAccessCode(true);
      } else if (
        (!item.isTaken && isOpened) ||
        (!HoldID && !item.isTaken)
      ) {
        setSelectedTableCircles((curr) => {
          const list = [
            ...curr,
            {
              objectId: obj.id,
              itemID: item.id,
              HoldID,
              TierID: item.tierID,
              index: item.index,
              tableName: obj.name,
            },
          ];
          const unique = filterUniqueSelectedTableCircles(list);
          filterByTierID(unique);
          return unique;
        });
      }
    }

    event.stopPropagation();
    event.preventDefault();
    // break if you only allow one circle per click:
    break;
  }
}
 else if (obj.type === "generalArea") {
      const centerX = obj.x + obj.width / 2;
      const centerY = obj.y + obj.height / 2;
      const translatedMouseX = mouseX - centerX;
      const translatedMouseY = mouseY - centerY;

      // Reverse the rotation
      const angle = (-obj.rotation * Math.PI) / 180; // Convert degrees to radians and reverse
      const rotatedMouseX =
        translatedMouseX * Math.cos(angle) - translatedMouseY * Math.sin(angle);
      const rotatedMouseY =
        translatedMouseX * Math.sin(angle) + translatedMouseY * Math.cos(angle);
      const assigned = findTicket(obj.tierID);
      if (
        rotatedMouseX >= -obj.width / 2 &&
        rotatedMouseX <= obj.width / 2 &&
        rotatedMouseY >= -obj.height / 2 &&
        rotatedMouseY <= obj.height / 2 &&
        assigned
      ) {
        const findObj = selectedArea.find((obj1) => {
          return obj1.id === obj.id;
        });
        if (findObj !== undefined) {
          setSelectedArea((current) => {
            return current.filter((n) => {
              return n.id !== obj.id;
            });
          });
        } else {
          setSelectedArea((current) => {
            let newObj = { ...obj, quantity: 1 };

            let newFilter = [...current, newObj];
            const filtered = filterUniqueSelectedAreas(newFilter);
            filterByTierID(filtered);
            return filtered;
          });
        }
      }
    }
  });
};
